/// <reference path="../../meevoMessenger.module.ts" />

module Meevo.Plugins.Controls {
    class ExpandedImageModalController {

        static $inject = ['imgSrc', '$mdDialog']

        public imgSrc: string;

        constructor(
            imgSrc: string,
            private $mdDialog: angular.material.IDialogService
        ) {
            this.imgSrc = imgSrc;
        }

        close = () => {
            this.$mdDialog.hide();
        }
    }

    angular.module('meevo.plugins.meevoMessenger')
        .controller('meevo.plugins.ExpandedImageModalController', ExpandedImageModalController);
}
